'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reselect = require('reselect');

var _propagatePropsToChildren = require('../../helpers/propagatePropsToChildren');

var _propagatePropsToChildren2 = _interopRequireDefault(_propagatePropsToChildren);

var _loading = require('../../atoms/loading');

var _loading2 = _interopRequireDefault(_loading);

var _messages = require('../../messages');

var _messages2 = _interopRequireDefault(_messages);

var _selectCulture = require('../../selectors/context/selectCulture');

var _reduceCulture = require('../../actions/context/reduceCulture');

var _reduceCulture2 = _interopRequireDefault(_reduceCulture);

var _en = require('react-intl/locale-data/en');

var _en2 = _interopRequireDefault(_en);

var _fr = require('react-intl/locale-data/fr');

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_LOCALE = window.navigator.languages[0].substr(0, 2);

(0, _reactIntl.addLocaleData)(_en2.default);
(0, _reactIntl.addLocaleData)(_fr2.default);

var Language = function (_React$Component) {
    _inherits(Language, _React$Component);

    function Language(props) {
        _classCallCheck(this, Language);

        var _this = _possibleConstructorReturn(this, (Language.__proto__ || Object.getPrototypeOf(Language)).call(this, props));

        _this.setMessages = function (messages) {
            if (messages) {
                _this.setState({
                    messages: {
                        en: _this.formatTranslationMessages('en', _extends({}, messages['en'], _this.state.messages['en'])),
                        fr: _this.formatTranslationMessages('fr', _extends({}, messages['fr'], _this.state.messages['fr']))
                    }
                });
            }
        };

        _this.state = {
            messages: {
                en: {},
                fr: {}
            },
            loaded: false
        };
        return _this;
    }

    _createClass(Language, [{
        key: 'formatTranslationMessages',
        value: function formatTranslationMessages(locale, messages) {
            var defaultFormattedMessages = locale !== DEFAULT_LOCALE ? this.formatTranslationMessages(DEFAULT_LOCALE, messages) : {};
            return Object.keys(messages).reduce(function (formattedMessages, key) {
                var message = messages[key];
                if (!message && locale !== DEFAULT_LOCALE) {
                    message = defaultFormattedMessages[key];
                }
                return Object.assign(formattedMessages, _defineProperty({}, key, message));
            }, {});
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Initialize
            this.setState({
                messages: {
                    en: this.formatTranslationMessages('en', _extends({}, this.props.messages['en'], _messages2.default['en'])),
                    fr: this.formatTranslationMessages('fr', _extends({}, this.props.messages['fr'], _messages2.default['fr']))
                },
                loaded: true
            });

            // Handle culture based on priority: override > localStorage > existing Redux > browser
            if (this.props.overrideCulture) {
                this.props.doReduceCulture(this.props.overrideCulture);
            } else {
                var storedCulture = localStorage.getItem('preferredCulture');

                if (storedCulture) {
                    this.props.doReduceCulture(storedCulture);
                } else if (this.props.culture) {
                    // If Redux already has a culture but it's not in localStorage, save it
                    localStorage.setItem('preferredCulture', this.props.culture);
                } else {
                    // No override, no localStorage, no Redux - use browser default
                    var detectedCulture = window.navigator.languages[0].substr(0, 2) + '-CA';
                    this.props.doReduceCulture(detectedCulture);
                    localStorage.setItem('preferredCulture', detectedCulture);
                    this.props.context.doSetSession();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // When culture changes in Redux, update localStorage unless it was from an override
            if (!this.props.overrideCulture && this.props.culture && this.props.culture !== prevProps.culture) {
                localStorage.setItem('preferredCulture', this.props.culture);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var context = _extends({}, this.props.context, {
                culture: this.props.culture,
                doReduceCulture: this.props.doReduceCulture,
                doSetMessages: function doSetMessages(value) {
                    return _this2.setMessages(value);
                }
            });
            var child = (0, _propagatePropsToChildren2.default)(this.props.children, { context: context })[0];

            // Determine which culture to use with proper fallback chain
            var displayCulture = void 0;
            if (this.props.overrideCulture) {
                displayCulture = this.props.overrideCulture.replace('-CA', '');
            } else if (this.props.culture) {
                displayCulture = this.props.culture.replace('-CA', '');
            } else {
                // If we don't have culture in Redux yet, check localStorage
                var storedCulture = localStorage.getItem('preferredCulture');
                if (storedCulture) {
                    displayCulture = storedCulture.replace('-CA', '');
                } else {
                    // Last resort: browser default
                    displayCulture = DEFAULT_LOCALE;
                }
            }

            // Verify we have messages for this culture
            var hasMessages = this.state.messages && this.state.messages[displayCulture];

            return _react2.default.createElement(
                'div',
                null,
                this.state.loaded ? _react2.default.createElement(
                    _reactIntl.IntlProvider,
                    {
                        locale: displayCulture,
                        key: displayCulture,
                        messages: hasMessages ? this.state.messages[displayCulture] : {},
                        defaultLocale: DEFAULT_LOCALE
                    },
                    child
                ) : _react2.default.createElement(_loading2.default, { visible: true })
            );
        }
    }]);

    return Language;
}(_react2.default.Component);

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    culture: (0, _selectCulture.selectCulture)()
});

function mapDispatchToProps(dispatch) {
    return {
        doReduceCulture: function doReduceCulture(val) {
            return dispatch((0, _reduceCulture2.default)(val));
        }
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Language);